"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMultiFileUploadIntl = void 0;
var createMultiFileUploadIntl = function (intl) {
    return intl ? _createMultiFileUploadIntl(intl) : {
        placeholder: "No files chosen",
        browse: "Browse for files",
        filesAtMax: "File limit reached"
    };
};
exports.createMultiFileUploadIntl = createMultiFileUploadIntl;
var _createMultiFileUploadIntl = function (intl) { return ({
    placeholder: intl.formatMessage({ id: "VSX.MultiFileUpload.placeholder", defaultMessage: "No files chosen" }),
    browse: intl.formatMessage({ id: "VSX.MultiFileUpload.browse", defaultMessage: "Browse for files" }),
    filesAtMax: intl.formatMessage({ id: "VSX.MultiFileUpload.filesAtMax", defaultMessage: "File limit reached" })
}); };
